import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyACWi23zvxsW18RWhZeZ9afeLVwhEVQM-k",
  authDomain: "zangula-website-59100.firebaseapp.com",
  projectId: "zangula-website-59100",
  storageBucket: "zangula-website-59100.firebasestorage.app",
  messagingSenderId: "548467337281",
  appId: "1:548467337281:web:23d4e3f35a60770e6dbec0",
  measurementId: "G-PFTXZ140SE",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth();

const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });
export const signInWithGoogle = () => signInWithPopup(auth, provider);

export default app;
